module.exports = __webpack_public_path__ + "static/media/whitelogo.ec19ec10.svg";